var render, staticRenderFns
import script from "./RecruitmentCta.vue?vue&type=script&lang=js&"
export * from "./RecruitmentCta.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentCta.vue?vue&type=style&index=0&id=2ca35c37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca35c37",
  null
  
)

export default component.exports